import React from 'react';
import { Alert, Table }  from 'reactstrap';
import * as Icon from 'react-feather';
import { ConfirmModal } from '../Modals/Confirm';

export function ConfirmDeleteTenantModal(props) {
    return (
        <ConfirmModal 
            isOpen={props.isOpen}
            toggle={props.toggle} 
            handleConfirm={(e) => props.handleConfirm(props.tenant, e)}
            title="Delete Organisation?"
            confirmText="Yes, Delete Organisation"
            confirmColor="danger"
            confirmIcon={Icon.Trash2}
        >
            <Alert color="warning">
                <strong>Are you sure you wish to delete the following Organisation?</strong>
            </Alert>

            <Table bordered>
                <thead>
                    <tr>
                        <th className="col-xs-4">Name</th>
                        <th className="col-xs-4">Identifier</th>
                        <th className="col-xs-4">OwnerId</th>
                        <th className="col-xs-4">DareCreated</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{props.tenant.name}</td>
                        <td>{props.tenant.identifier}</td>
                        <td>{props.tenant.ownerId}</td>
                        <td>{props.tenant.dateCreated}</td>
                    </tr>
                </tbody>
            </Table>
        </ConfirmModal>
    );
}